// Types
import { RootState } from 'types/RootState.types';

export const getAccountCreationSuccessErrorSelector = (state: RootState) =>
  state.createAccount?.accountCreationSuccessError;
export const getJoinMyJLFailedSelector = (state: RootState) => state.createAccount?.joinMyJLFailed || false;
export const getJoinMyJLSuccessSelector = (state: RootState) => state.createAccount?.joinMyJLApiCallComplete || false;
